import { TooltipProvider } from "@/components/tooltip";
import { useStytchMemberSession } from "@stytch/react/b2b";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import {
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import { tsr } from "./api";
import { Header } from "./components/header";
import { Toaster } from "./components/toaster";
import AuthenticatePage from "./pages/Auth/authenticate";
import LoginPage from "./pages/Auth/login";
import HomeRedirect from "./pages/HomeRedirect";
import DAGEditor from "./pages/Projects/Editor/DAGEditor";
import ProjectHeader from "./pages/Projects/Editor/header";
import ProjectEditor from "./pages/Projects/Editor/page";
import Projects from "./pages/Projects/page";
import TaskRunner from "./pages/TaskRunner/page";
import TasksHome from "./pages/Tasks/page";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { session } = useStytchMemberSession();

  if (session) {
    return children;
  }

  console.log("Not authenticated, redirecting to login");
  return <Navigate to={"/login"} />;
};

const App = () => {
  return (
    <Router>
      <QueryClientProvider client={queryClient}>
        <tsr.ReactQueryProvider>
          <TooltipProvider>
            <div className="bg-white overflow-auto">
              <Routes>
                <Route path="/login" element={<LoginPage />} />
                <Route path="/authenticate" element={<AuthenticatePage />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <>
                        <Header />
                        <Routes>
                          <Route path="/" element={<TasksHome />} />
                          <Route path="tasks/:id" element={<TaskRunner />} />
                        </Routes>
                      </>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/projects/*"
                  element={
                    <ProtectedRoute>
                      <>
                        <ProjectHeader />
                        <Routes>
                          <Route path="/" element={<Projects />} />
                          <Route path=":id/*" element={<ProjectEditor />} />
                        </Routes>
                      </>
                    </ProtectedRoute>
                  }
                />
                <Route
                  path="/workflows/*"
                  element={
                    <ProtectedRoute>
                      <>
                        <ProjectHeader />
                        <Routes>
                          <Route path=":id/*" element={<DAGEditor />} />
                        </Routes>
                      </>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </div>
            <Toaster />
          </TooltipProvider>
        </tsr.ReactQueryProvider>
      </QueryClientProvider>
    </Router>
  );
};

export default App;
